import { PageWithLayout } from '@/pages/_app';
import { Navigate, useSearchParams } from 'react-router-dom';

const CustomerDetailsOld: PageWithLayout = () => {
    const [searchParams] = useSearchParams();

    const id = searchParams.get('id');

    if (!id) {
        return <Navigate to='/kunden' replace />;
    }

    // Get all search params except 'id'
    const params = new URLSearchParams(searchParams);
    params.delete('id');
    const queryString = params.toString();

    const redirectUrl = queryString
        ? `/kunden/${id}?${queryString}`
        : `/kunden/${id}`;

    return <Navigate to={redirectUrl} replace />;
};

CustomerDetailsOld.isProtected = true;
CustomerDetailsOld.permissions = [];

export default CustomerDetailsOld;
